// Small parsers for CMS-supplied legal/about content.
//
// parseLegalHtml(html) — extracts an optional "Last updated: …" string and
// strips the leading <h1>...</h1> so the page hero (which already renders the
// title) doesn't visually duplicate it.
//
// splitAboutParagraphs(text) — turns the about plain-text blob into an array
// of paragraphs, splitting on blank lines or single newlines.

const LAST_UPDATED_RE = /<p[^>]*>\s*Last updated:\s*([^<]+?)\s*<\/p>/i;
const LEADING_H1_RE = /^\s*<h1[^>]*>[^<]*<\/h1>\s*/i;

export const parseLegalHtml = (html) => {
  if (typeof html !== "string" || !html.length) {
    return { lastUpdated: "", content: "" };
  }

  let lastUpdated = "";
  const match = html.match(LAST_UPDATED_RE);
  if (match) {
    lastUpdated = match[1].trim();
  }

  // Remove the first <p>Last updated: ...</p> and the leading <h1> so the
  // hero owns those bits of metadata exclusively.
  const content = html.replace(LAST_UPDATED_RE, "").replace(LEADING_H1_RE, "");

  return { lastUpdated, content };
};

export const splitAboutParagraphs = (text) => {
  if (typeof text !== "string" || !text.length) return [];
  // Prefer blank-line separated paragraphs; fall back to single newlines if
  // the CMS content is one long unsegmented string.
  const byBlankLine = text.split(/\n\s*\n+/).map((s) => s.trim()).filter(Boolean);
  if (byBlankLine.length > 1) return byBlankLine;

  const bySingleLine = text.split(/\n+/).map((s) => s.trim()).filter(Boolean);
  if (bySingleLine.length > 1) return bySingleLine;

  return [text.trim()];
};
